import { render } from "./AccountLoginGlHomes.vue?vue&type=template&id=56a96f1a&scoped=true"
import script from "./AccountLoginGlHomes.vue?vue&type=script&lang=js"
export * from "./AccountLoginGlHomes.vue?vue&type=script&lang=js"

import "./AccountLoginGlHomes.vue?vue&type=style&index=0&id=56a96f1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a96f1a"]])

export default __exports__